export const useDocumentZoomControl = (documentId: string) =>
  defineStore(`/document/zoom/controller/${documentId}`, () => {
    const zoomFactor = ref(1);

    const setZoomFactor = (factor: number) => {
      zoomFactor.value = factor;
    };

    const zoomIn = () => {
      zoomFactor.value += 0.1;
    };

    const zoomOut = () => {
      zoomFactor.value -= 0.1;
    };

    return {
      zoomFactor,
      setZoomFactor,
      zoomIn,
      zoomOut,
    };
  });
